package frontend.modals

import AddressSelect
import ErrorString
import androidx.compose.runtime.*
import net.sergeych.ugdx.shared.ApiException
import net.sergeych.ugdx.shared.api.ApiAccount
import com.ionspin.kotlin.bignum.decimal.BigDecimal
import com.ionspin.kotlin.bignum.decimal.toBigDecimal
import components.TButton
import components.TForm
import components.TLink
import components.TTextInput
import frontend.App
import frontend.DepositContext
import frontend.components.Modal
import frontend.lib.MetaMask
import frontend.lib.classList
import frontend.lib.displayCurrencyCode
import frontend.models.User
import frontend.pages.AccountAttachModal
import frontend.pages.Wallet
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text

@Composable
fun DepositModal(app: App, user: User, toAccount: ApiAccount, onClose: () -> Unit) {
    val scope = rememberCoroutineScope()
//    val user = wallet.user
    var error: String? by mutableStateOf(null)
    var isAttachETH by remember { mutableStateOf(false) }
    var isLoading by remember { mutableStateOf(false) }

    fun runDeposit(deposit: DepositContext) {
        isLoading = true
        if (deposit.amount == "") {
            error = "Amount can't be empty"
            isLoading = false
            return
        }
        val amount: BigDecimal? = try { deposit.amount.toBigDecimal() } catch(e: Throwable) {
            error = "Amount is not a valid number"
            isLoading = false
            null
        }

        if (amount == null) return

        scope.launch {
            val receiverAddress: String? = try { deposit.to.getImportAddress() } catch (e: ApiException) {
                error = e.text
                isLoading = false
                null
            }

            if (receiverAddress != null) {
                try {
                    deposit.from?.let {
                        val transactionHash = MetaMask.pay(amount, it.address, receiverAddress)
                        println("ETH transactoin hash: $transactionHash")
                        error = null
                        isLoading = false
                        onClose()
                    } ?: run {
                        error = "Enter valid payment address"
                        isLoading = false
                    }
                } catch (e: dynamic) {
                    val code: Int = e.code
                    if (code == -32602) error = "Your payment address is not active in MetaMask"
                    if (code == 4001) error = "You cancelled MetaMask transaction"
                    isLoading = false
                }
            }
        }
    }

    if (!isAttachETH) app.deposit?.let {
        val deposit = it

        Modal(onClose = { onClose() }) {
            TForm() {
                H3(attrs = { classList("text-lg leading-6 font-medium text-gray-900") }) {
                    Text("Deposit ${displayCurrencyCode(deposit.to.currencyCode)} to ${deposit.to.name ?: deposit.to.id.toString()}")
                }

                AddressSelect("eth", deposit.from) {
                    options(user.addresses)
                    onChange { app.deposit = deposit.copy(from = it) }
                    loadAddresses = {
                        user.loadAddresses(true)
                        app.deposit = deposit.copy(from = user.addresses.firstOrNull())
                    }
                    label {
                        Text("Select payment address or ")
                        TLink("attach new one") { isAttachETH = true }
                    }
                }

                TTextInput("amount", deposit.amount) {
                    numeric()
                    onInput { app.deposit = deposit.copy(amount = it) }
                    label { Text("amount") }
                }

                if (error !== null) ErrorString(error ?: "")

                TButton(attrs = {
                    onClick { runDeposit(deposit) }
                    isLoading(isLoading)
                }) {
                    Text("Create deposit")
                }
            }
        }
    }
    else {
        AccountAttachModal(user) {
            val fromAccount = it
            app.deposit?.let { app.deposit = it.copy(from = fromAccount) }
            isAttachETH = false
        }
    }
}
